
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { ScheduleSelector } from "./ScheduleSelector";
import { InstructorSelector } from "./InstructorSelector";

interface ClassFormInputsProps {
  title: string;
  setTitle: (value: string) => void;
  description: string;
  setDescription: (value: string) => void;
  instructor: string;
  setInstructor: (value: string) => void;
  schedule: string;
  setSchedule: (value: string) => void;
  capacity: number;
  setCapacity: (value: number) => void;
  duration: number;
  setDuration: (value: number) => void;
  gymId?: string;
  userRole?: string;
}

export const ClassFormInputs = ({
  title,
  setTitle,
  description,
  setDescription,
  instructor,
  setInstructor,
  schedule,
  setSchedule,
  capacity,
  setCapacity,
  duration,
  setDuration,
  gymId,
  userRole,
}: ClassFormInputsProps) => {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="title" className="text-sm font-medium text-white/90">
          Título de la clase
        </Label>
        <Input
          id="title"
          placeholder="Ejemplo: Zumba Fitness"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
          className="border-white/20 bg-black/30 text-white"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="description" className="text-sm font-medium text-white/90">
          Descripción de la clase
        </Label>
        <Textarea
          id="description"
          placeholder="Ejemplo: Clase de cardio con música latina para todos los niveles"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          required
          className="min-h-[100px] border-white/20 bg-black/30 text-white"
        />
      </div>
      
      <InstructorSelector
        value={instructor}
        onChange={setInstructor}
        gymId={gymId}
        userRole={userRole}
      />
      
      <ScheduleSelector
        value={schedule}
        onChange={setSchedule}
      />
      
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="capacity" className="text-sm font-medium text-white/90">
            Capacidad
          </Label>
          <Input
            id="capacity"
            type="number"
            placeholder="Ejemplo: 20"
            value={capacity}
            onChange={(e) => setCapacity(parseInt(e.target.value))}
            required
            min="1"
            className="border-white/20 bg-black/30 text-white"
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="duration" className="text-sm font-medium text-white/90">
            Duración (minutos)
          </Label>
          <Input
            id="duration"
            type="number"
            placeholder="Ejemplo: 60 minutos"
            value={duration}
            onChange={(e) => setDuration(parseInt(e.target.value))}
            required
            min="1"
            className="border-white/20 bg-black/30 text-white"
          />
        </div>
      </div>
    </>
  );
};
